/**
 * Valid snippet categories for the Kemu platform
 * These categories are used in both the CreateSnippetModal and SnippetsDrawer components
 */
export const SNIPPET_CATEGORIES = [
	'AI',
	'Chat',
	'Data Science',
	'Education',
	'Hardware Integrations',
	'Machine Learning',
	'Agentic Workflows',
	'Object Detection',
	'Machine Vision',
	'Snippets',
	'Testing',
	'Visualization',
	'Other'
] as const;

export const colorByCategoryName = (categoryName: typeof SNIPPET_CATEGORIES[number]) => {
  // Returns antd color name for each snippet category
  switch ((categoryName || '').toLowerCase()) {
    case 'ai':
      return 'geekblue';
    case 'chat':
      return 'cyan';
    case 'data science':
      return 'lime';
    case 'education':
      return 'gold';
    case 'hardware integrations':
      return 'volcano';
    case 'machine learning':
      return 'purple';
    case 'agentic workflows':
      return 'blue';
    case 'object detection':
      return 'magenta';
    case 'machine vision':
      return 'orange';
    case 'snippets':
      return 'processing';
    case 'testing':
      return 'error';
    case 'visualization':
      return 'success';
    case 'other':
      return 'warning';
		default:
			return 'geekblue';
  }
};

export const encodeSvgToBase64 = (svg: string): string => {
  return btoa(svg);
};

export const decodeSvgFromBase64 = (encodedSvg: string): string => {
	try {
		return atob(encodedSvg);
	} catch (error) {
		console.error('Error decoding SVG from base64:', error);
		return '';
	}
};

/**
 * Converts a SnippetEntity from the API to a UISnippet for Redux state
 * @param snippetEntity The snippet entity from the API
 * @param rawIconSvg Optional raw SVG string (for create operations)
 * @returns UISnippet object for Redux state
 */
export const convertSnippetEntityToUI = (snippetEntity: any, rawIconSvg?: string) => {
	return {
		...snippetEntity,
		description: snippetEntity.shortDescription,
		content: snippetEntity.contents,
		category: {
			name: snippetEntity.category,
			color: colorByCategoryName(snippetEntity.category as typeof SNIPPET_CATEGORIES[number]),
		},
		rating: snippetEntity.rating || 0,
		totalRating: snippetEntity.totalRating || 0,
		icon: snippetEntity.iconSvg ? `data:image/svg+xml;base64,${snippetEntity.iconSvg}` : undefined,
		iconSvg: rawIconSvg || snippetEntity.iconSvg,
	};
};

export type SnippetCategory = typeof SNIPPET_CATEGORIES[number];
